import React from 'react';

/**
 * ============================================
 * Product Skeleton Component
 * ============================================
 * Loading placeholder for product cards
 */

const ProductSkeleton = () => {
    return (
        <div className="glass-light rounded-3xl overflow-hidden border border-white/10 animate-pulse">
            {/* Image Skeleton */}
            <div className="aspect-[4/3] bg-luxury-slate/50">
                <div className="w-full h-full shimmer" />
            </div>
            
            {/* Content Skeleton */}
            <div className="p-6 space-y-5">
                {/* Title */}
                <div className="space-y-3">
                    <div className="h-6 bg-luxury-slate/50 rounded-2xl w-3/4 shimmer" />
                    <div className="h-3 bg-luxury-slate/50 rounded-xl w-1/3 shimmer" />
                </div>
                
                {/* Description */}
                <div className="space-y-2">
                    <div className="h-4 bg-luxury-slate/50 rounded-xl w-full shimmer" />
                    <div className="h-4 bg-luxury-slate/50 rounded-xl w-2/3 shimmer" />
                </div>
                
                {/* Stats Grid */}
                <div className="grid grid-cols-2 gap-4">
                    <div className="h-20 bg-luxury-slate/50 rounded-2xl shimmer" />
                    <div className="h-20 bg-luxury-slate/50 rounded-2xl shimmer" />
                </div>
                
                {/* Price Section */}
                <div className="pt-5 border-t border-white/10 flex justify-between items-center">
                    <div className="space-y-2">
                        <div className="h-3 bg-luxury-slate/50 rounded-xl w-20 shimmer" />
                        <div className="h-7 bg-luxury-slate/50 rounded-xl w-28 shimmer" />
                    </div>
                    <div className="h-5 bg-luxury-slate/50 rounded-xl w-24 shimmer" />
                </div>
            </div>
        </div>
    );
};

/**
 * ============================================
 * Product Grid Skeleton
 * ============================================
 * Award-winning masonry loading state
 */

export const ProductGridSkeleton = ({ count = 6 }) => {
    const patterns = [
        'col-span-12 lg:col-span-7 row-span-2',
        'col-span-12 sm:col-span-6 lg:col-span-5 row-span-2',
        'col-span-12 sm:col-span-6 lg:col-span-4 row-span-1',
        'col-span-12 lg:col-span-8 row-span-1',
        'col-span-12 sm:col-span-6 lg:col-span-4 row-span-2',
        'col-span-12 sm:col-span-6 lg:col-span-4 row-span-1',
    ];

    return (
        <div className="grid grid-cols-12 gap-6 lg:gap-8 auto-rows-[280px]">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className={`${patterns[index % patterns.length]} glass-light rounded-3xl overflow-hidden border border-white/10 animate-pulse`}>
                    <div className="w-full h-full shimmer bg-luxury-slate/50" />
                </div>
            ))}
        </div>
    );
};

export default ProductSkeleton;
